var dropdownLabel = 'fx_2d2fb1e5_1kgieot0';

export { dropdownLabel };
//# sourceMappingURL=label.vanilla.mjs.map
